export default __webpack_public_path__ + "static/media/polygon_green.02f88619.svg";